import { Button } from "primereact/button"
import { Divider } from "primereact/divider"
import { useState } from "react"

export const ButtonsInstallment = ({ installment, selectedMonthTinkoff, setSelectedMonthTinkoff }) => {

    return (
        <>
            <div className="buttons block md:hidden p-1 mt-3">
                {installment.map((item, idx) => {

                    return (
                        <Button key={idx} className={+item === selectedMonthTinkoff ? 'btn-month active mr-3' : 'btn-month mr-3'} onClick={() => setSelectedMonthTinkoff(+item)}>
                            {item} {+item === 3 || +item === 24 ? 'месяца' : 'месяцев'}
                        </Button>
                    )
                })}
            </div>
            <div className={installment.length > 4 ? "hidden installment md:flex mt-6 lg:justify-content-center" : "hidden installment md:flex mt-6 lg:justify-content-between"}>
                {installment.map((item, idx) => {

                    return (

                        <div key={idx} className={+item === +installment[installment.length - 1] ? 'w-1' : 'w-full' && installment.length > 4 ? 'w-20' : 'w-full'}>
                            <div className={selectedMonthTinkoff >= item ? 'red flex flex-column' : 'gray flex flex-column'}>
                                <div className="flex">
                                    <div>
                                        <Button className="point" onClick={() => setSelectedMonthTinkoff(+item)}></Button>
                                    </div>

                                    <div className={selectedMonthTinkoff > +item ? 'color flex w-full' : 'flex w-full'}>
                                        <Divider className={+item === +(installment[installment.length - 1]) ? 'hidden' : ''} />
                                    </div>
                                </div>

                                <p className="label-month">{item} мес.</p>
                            </div>

                        </div>
                    )
                })}
            </div>
        </>
    )
}